(() => {
  'use strict';

  const root = document.querySelector('[data-muah-pdp]');
  if (!root) return;

  const form = root.querySelector('[data-muah-pdp-form]');
  const variantInput = root.querySelector('[data-muah-variant-id]');
  const atc = root.querySelector('[data-muah-atc]');
  const atcText = root.querySelector('[data-muah-atc-text]');
  const priceRow = root.querySelector('[data-muah-price-row]');
  const qtyInput = root.querySelector('[data-muah-qty-input]');
  const qtyMinus = root.querySelector('[data-muah-qty-minus]');
  const qtyPlus = root.querySelector('[data-muah-qty-plus]');
  const sticky = root.querySelector('[data-muah-pdp-sticky]');
  const stickyAtc = root.querySelector('[data-muah-sticky-atc]');
  const stickyPrice = root.querySelector('[data-muah-sticky-price]');
  const stickyImg = root.querySelector('[data-muah-sticky-img]');
  const notifyBtn = root.querySelector('[data-muah-notify]');
  const stickyNotifyBtn = root.querySelector('[data-muah-sticky-notify]');

  // Texte aus <script data-muah-i18n-pdp> der Section (window.muahPdpT), deutscher Fallback
  const T = (k, fb) => {
    if (typeof window.muahPdpT === 'function') return window.muahPdpT(k, fb);
    try {
      const el = document.querySelector('script[data-muah-i18n-pdp]');
      const v = el ? JSON.parse(el.textContent)[k] : null;
      return (typeof v === 'string' && v && v.indexOf('translation missing') !== 0) ? v.replace(/__([a-z]+)__/g, '{$1}') : fb;
    } catch (e) { return fb; }
  };
  // Zaehlformen sind mit count 7 gerendert: erste Zahl durch die echte Anzahl ersetzen
  const withCount = (s, n) => String(s).replace(/\d+/, String(n));
  // Einheit (Metafeld muah.anzahl_einheit, intern "Tafel"/"Stück") sprachunabhaengig erkennen
  const unitKind = (e) => {
    const s = String(e || '').trim().toLowerCase();
    if (['tafel', 'tafeln', 'bar', 'bars', 'tablet'].includes(s)) return 'tafel';
    if (['stück', 'stueck', 'stk', 'stk.', 'piece', 'pieces', 'adet'].includes(s)) return 'stueck';
    return '';
  };

  const variantsScript = document.querySelector('script[data-muah-variants]');
  let variants = [];
  try { variants = JSON.parse(variantsScript.textContent); } catch (e) { variants = []; }

  // Grundpreis + Fuellmenge je Variante aus der Section ergaenzen (PAngV, pro 1 kg)
  const unitsScript = document.querySelector('script[data-muah-variant-units]');
  if (unitsScript) {
    try {
      const units = JSON.parse(unitsScript.textContent);
      const byId = {};
      units.forEach((u) => { byId[String(u.id)] = u; });
      variants.forEach((v) => {
        const u = byId[String(v.id)];
        if (u) {
          v.unit_price = u.unit_price;
          v.unit_price_measurement = u.unit_price_measurement;
          v.muah_anzahl = Number(u.anzahl) || 1;
          v.muah_einheit = u.einheit || 'Tafel';
        }
      });
    } catch (e) { /* ohne Zusatzdaten bleibt der serverseitige Stand */ }
  }

  const fieldsets = [...root.querySelectorAll('[data-muah-option-index]')];

  const fmtMoney = (cents) => {
    const parts = (cents / 100).toFixed(2).split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return `${parts[0]},${parts[1]} €`;
  };
  const fmtQty = (n) => {
    const num = Number(n);
    if (!isFinite(num)) return '';
    return Number.isInteger(num) ? String(num) : String(num).replace('.', ',');
  };
  const netQtyEl = root.querySelector('[data-muah-net-qty]');
  const netRowEl = root.querySelector('[data-muah-net-row]');
  const perPieceEl = root.querySelector('[data-muah-per-piece]');
  const unitPriceEl = root.querySelector('[data-muah-unit-price]');

  function updateUnitInfo(variant) {
    if (!variant || !('unit_price_measurement' in variant)) return;
    const m = variant.unit_price_measurement;
    if (netQtyEl) {
      if (m && Number(m.quantity_value) > 0 && m.quantity_unit) {
        netQtyEl.textContent = `${fmtQty(m.quantity_value)} ${m.quantity_unit}`;
        if (netRowEl) netRowEl.hidden = false;
      } else {
        netQtyEl.textContent = '';
        if (netRowEl) netRowEl.hidden = true;
      }
    }
    if (perPieceEl) {
      const n = Number(variant.muah_anzahl) || 1;
      if (n > 1 && variant.price) {
        const einh = variant.muah_einheit || 'Tafel';
        const kind = unitKind(einh);
        const pm = fmtMoney(Math.round(variant.price / n));
        let txt;
        if (kind === 'tafel') txt = withCount(T('stueckpreis_tafel', '7 Tafeln · {p} pro Tafel'), n);
        else if (kind === 'stueck') txt = withCount(T('stueckpreis_stueck', '7 Stück · {p} pro Stück'), n);
        else txt = T('stueckpreis_einheit', '{n} {e} · {p} pro {e}').split('{n}').join(String(n)).split('{e}').join(einh);
        perPieceEl.textContent = txt.split('{p}').join(pm);
        perPieceEl.hidden = false;
      } else {
        perPieceEl.textContent = '';
        perPieceEl.hidden = true;
      }
    }
    if (unitPriceEl) {
      if (m && variant.unit_price && m.reference_unit) {
        const refVal = Number(m.reference_value);
        const ref = (refVal === 1 || !refVal) ? m.reference_unit : `${fmtQty(refVal)} ${m.reference_unit}`;
        unitPriceEl.textContent = `${fmtMoney(variant.unit_price)} / ${ref}`;
        unitPriceEl.hidden = false;
      } else {
        unitPriceEl.textContent = '';
        unitPriceEl.hidden = true;
      }
    }
  }

  const stage = root.querySelector('[data-muah-stage]');
  const slides = stage ? [...stage.querySelectorAll('[data-muah-slide]')] : [];
  const thumbs = [...root.querySelectorAll('[data-muah-thumb]')];

  const showSlide = (index) => {
    if (!slides.length) return;
    slides.forEach((el, i) => el.classList.toggle('is-active', i === index));
    thumbs.forEach((el, i) => el.classList.toggle('is-active', i === index));
  };
  thumbs.forEach((thumb) => {
    thumb.addEventListener('click', () => {
      const i = parseInt(thumb.dataset.muahThumbIndex, 10);
      if (!isNaN(i)) showSlide(i);
    });
  });
  const prev = root.querySelector('[data-muah-prev]');
  const next = root.querySelector('[data-muah-next]');
  // Nur durch die Medien der aktuell gewaehlten Sorte blaettern (muahFlavorMatch != '0').
  const visibleSlideIndices = () => slides.map((s, i) => i).filter((i) => slides[i].dataset.muahFlavorMatch !== '0');
  const stepSlide = (dir) => {
    const vis = visibleSlideIndices();
    if (vis.length < 2) return;
    const cur = slides.findIndex((s) => s.classList.contains('is-active'));
    let pos = vis.indexOf(cur);
    if (pos < 0) pos = 0;
    showSlide(vis[(pos + dir + vis.length) % vis.length]);
  };
  if (prev) prev.addEventListener('click', () => stepSlide(-1));
  if (next) next.addEventListener('click', () => stepSlide(1));

  function getSelected() {
    return fieldsets.map((fs) => {
      const checked = fs.querySelector('input[type="radio"]:checked');
      return checked ? checked.value : null;
    });
  }

  function setOption(idx, value) {
    const fs = fieldsets[idx];
    if (!fs) return;
    const target = fs.querySelector(`input[value="${cssEscape(value)}"]`);
    if (target) target.checked = true;
  }

  function cssEscape(s) {
    return String(s).replace(/(["\\])/g, '\\$1');
  }

  function variantMatches(variant, selected) {
    return selected.every((val, idx) => val === null || variant.options[idx] === val);
  }

  function findVariant(selected) {
    return variants.find((v) => selected.every((val, idx) => v.options[idx] === val));
  }

  function findAvailableVariantFor(idx, value, otherSelected) {
    const probe = [...otherSelected];
    probe[idx] = value;
    return variants.find((v) => v.available && probe.every((val, i) => val === null || v.options[i] === val));
  }

  function valueHasAnyVariant(idx, value, fixedSelected) {
    return variants.some((v) => {
      if (v.options[idx] !== value) return false;
      return fixedSelected.every((val, i) => i >= idx || val === null || v.options[i] === val);
    });
  }

  function valueHasAvailableVariant(idx, value, fixedSelected) {
    return variants.some((v) => {
      if (!v.available) return false;
      if (v.options[idx] !== value) return false;
      return fixedSelected.every((val, i) => i >= idx || val === null || v.options[i] === val);
    });
  }

  function updateTileImageForCurrent(idx, value, selected) {
    const fs = fieldsets[idx];
    if (!fs) return;
    if (fs.dataset.muahPickerStyle !== 'image') return;
    const probe = [...selected];
    probe[idx] = value;
    const m = variants.find((v) => probe.every((val, i) => val === null || v.options[i] === val));
    if (m && m.featured_image && m.featured_image.src) {
      const tile = fs.querySelector(`[data-muah-tile-value="${cssEscape(value)}"] img`);
      if (tile) tile.src = m.featured_image.src.replace(/(\.[^.\/]+)(\?|$)/, '_160x$1$2');
    }
  }

  function updateAvailability() {
    const selected = getSelected();

    fieldsets.forEach((fs, idx) => {
      const tiles = fs.querySelectorAll('.muah-pdp__tile');
      tiles.forEach((tile) => {
        const value = tile.dataset.muahTileValue;
        const exists = valueHasAnyVariant(idx, value, selected);
        const available = valueHasAvailableVariant(idx, value, selected);

        tile.classList.toggle('is-unavail', !exists);
        tile.classList.toggle('is-oos', exists && !available);

        if (fs.dataset.muahPickerStyle === 'image') {
          updateTileImageForCurrent(idx, value, selected);
        }
      });

      const checked = fs.querySelector('input[type="radio"]:checked');
      if (checked) {
        const checkedValue = checked.value;
        const stillExists = valueHasAnyVariant(idx, checkedValue, selected);
        if (!stillExists) {
          const firstValid = [...tiles].find((t) => valueHasAnyVariant(idx, t.dataset.muahTileValue, selected));
          if (firstValid) {
            setOption(idx, firstValid.dataset.muahTileValue);
          }
        }
      }

      const sel = fs.querySelector('[data-muah-option-selected]');
      const cur = fs.querySelector('input[type="radio"]:checked');
      if (sel) sel.textContent = cur ? cur.value : '';
    });
  }

  function filterMediaForFlavor() {
    const selected = getSelected();
    const currentFlavor = selected[0];
    if (!currentFlavor) return;

    const matchingThumbs = [];
    let matchingSlideIdx = -1;

    thumbs.forEach((t, i) => {
      const flavors = (t.dataset.muahThumbFlavors || '').split('|').filter(Boolean);
      const matches = flavors.length === 0 || flavors.includes(currentFlavor);
      t.style.display = matches ? '' : 'none';
      if (matches) matchingThumbs.push(i);
    });

    slides.forEach((s, i) => {
      const flavors = (s.dataset.muahSlideFlavors || '').split('|').filter(Boolean);
      const matches = flavors.length === 0 || flavors.includes(currentFlavor);
      s.dataset.muahFlavorMatch = matches ? '1' : '0';
      if (matches && matchingSlideIdx < 0 && s.classList.contains('is-active')) {
        matchingSlideIdx = i;
      }
    });
    // Pfeile nur zeigen, wenn die aktuelle Sorte mehr als ein Bild hat
    const visCount = slides.filter((s) => s.dataset.muahFlavorMatch !== '0').length;
    if (prev) prev.style.display = visCount > 1 ? '' : 'none';
    if (next) next.style.display = visCount > 1 ? '' : 'none';
  }

  function updateForVariant() {
    updateAvailability();
    const selected = getSelected();
    const variant = findVariant(selected);

    if (!variant) {
      if (atcText) atcText.textContent = T('nicht_verfuegbar', 'Nicht verfügbar');
      if (atc) atc.disabled = true;
      if (stickyAtc) stickyAtc.disabled = true;
      return;
    }

    if (variantInput) variantInput.value = variant.id;

    const sale = variant.compare_at_price && variant.compare_at_price > variant.price;
    const priceHtml = sale
      ? `<span class="muah-pdp__price muah-pdp__price--sale">${fmtMoney(variant.price)}</span><span class="muah-pdp__price-compare">${fmtMoney(variant.compare_at_price)}</span>`
      : `<span class="muah-pdp__price">${fmtMoney(variant.price)}</span>`;
    const block = priceRow ? priceRow.querySelector('.muah-pdp__price-block') : null;
    if (block) block.innerHTML = priceHtml;
    updateUnitInfo(variant);
    if (stickyPrice && !notifyBtn) stickyPrice.textContent = fmtMoney(variant.price);

    if (variant.available) {
      if (atc) atc.disabled = false;
      if (atcText) atcText.textContent = T('in_den_warenkorb', 'In den Warenkorb');
      if (stickyAtc) { stickyAtc.disabled = false; stickyAtc.textContent = T('in_den_warenkorb', 'In den Warenkorb'); }
    } else {
      if (atc) atc.disabled = true;
      if (atcText) atcText.textContent = T('ausverkauft', 'Ausverkauft');
      if (stickyAtc) { stickyAtc.disabled = true; stickyAtc.textContent = T('ausverkauft', 'Ausverkauft'); }
    }

    // Lagerstand-Anzeige (grüner Punkt) pro Variante aktualisieren
    const stockEl = root.querySelector('[data-muah-stock]');
    const stockText = root.querySelector('[data-muah-stock-text]');
    if (stockEl && stockText) {
      if (variant.available) {
        stockEl.classList.remove('is-out');
        const q = variant.inventory_quantity;
        if (variant.inventory_management && typeof q === 'number' && q > 0 && q <= 10) {
          stockText.textContent = withCount(T('nur_noch_lager', 'Nur noch 7 auf Lager'), q);
        } else {
          stockText.textContent = T('auf_lager', 'Auf Lager · sofort versandfertig');
        }
      } else {
        stockEl.classList.add('is-out');
        stockText.textContent = T('derzeit_ausverkauft', 'Derzeit ausverkauft');
      }
    }

    let targetMediaId = variant.featured_media ? variant.featured_media.id : null;
    if (!targetMediaId) {
      const flavor = variant.options[0];
      const sib = variants.find((vv) => vv.options[0] === flavor && vv.featured_media);
      if (sib) targetMediaId = sib.featured_media.id;
    }
    if (targetMediaId) {
      const idx = slides.findIndex((s) => parseInt(s.dataset.muahSlide, 10) === targetMediaId);
      if (idx >= 0) showSlide(idx);
    }

    filterMediaForFlavor();

    const activeThumb = thumbs.find((t) => t.classList.contains('is-active'));
    if (activeThumb && activeThumb.style.display === 'none') {
      const firstVisible = thumbs.find((t) => t.style.display !== 'none');
      if (firstVisible) {
        const i = parseInt(firstVisible.dataset.muahThumbIndex, 10);
        if (!isNaN(i)) showSlide(i);
      }
    }

    if (stickyImg && variant.featured_image && variant.featured_image.src) {
      stickyImg.src = variant.featured_image.src.replace(/(\.[^.\/]+)(\?|$)/, '_120x$1$2');
    }

    const url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    history.replaceState({}, '', url.toString());
  }

  root.querySelectorAll('.muah-pdp__tile-input').forEach((input) => {
    input.addEventListener('change', updateForVariant);
  });

  function setQty(val) {
    if (!qtyInput) return;
    const max = parseInt(qtyInput.max, 10) || 99;
    const n = Math.max(1, Math.min(max, val));
    qtyInput.value = n;
  }
  if (qtyMinus) qtyMinus.addEventListener('click', () => setQty((parseInt(qtyInput.value, 10) || 1) - 1));
  if (qtyPlus) qtyPlus.addEventListener('click', () => setQty((parseInt(qtyInput.value, 10) || 1) + 1));
  if (qtyInput) qtyInput.addEventListener('change', () => setQty(parseInt(qtyInput.value, 10) || 1));

  async function submitToCart() {
    if (!form) return;
    const formData = new FormData(form);
    const original = atcText ? atcText.textContent : T('in_den_warenkorb', 'In den Warenkorb');
    if (atc) atc.classList.add('is-loading');
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: formData,
      });
      const data = await res.json();
      if (!res.ok) throw data;
      if (atc) {
        atc.classList.remove('is-loading');
        atc.classList.add('is-success');
        if (atcText) atcText.textContent = '✓ ' + T('hinzugefuegt', 'Hinzugefügt');
      }
      document.dispatchEvent(new CustomEvent('muah:cart:open'));
      if (window.muahToast) window.muahToast(T('toast_hinzugefuegt', 'In den Warenkorb gelegt') + ' ✓', { type: 'success' });
      setTimeout(() => {
        if (atc) atc.classList.remove('is-success');
        if (atcText) atcText.textContent = original;
      }, 1800);
    } catch (err) {
      if (atc) atc.classList.remove('is-loading');
      if (atcText) atcText.textContent = original || T('in_den_warenkorb', 'In den Warenkorb');
      if (window.muahToast) window.muahToast(T('toast_fehler', 'Konnte nicht in den Korb gelegt werden'), { type: 'error' });
    }
  }

  if (form) form.addEventListener('submit', (e) => {
    if (notifyBtn) return;
    e.preventDefault();
    submitToCart();
  });
  if (stickyAtc) stickyAtc.addEventListener('click', submitToCart);

  function openNotifyDialog() {
    const email = prompt(T('notify_prompt', 'Trag deine E-Mail ein, wir melden uns sobald das Produkt verfügbar ist:'));
    if (!email) return;
    alert(T('notify_danke', 'Danke! Wir benachrichtigen {email} sobald es losgeht.').split('{email}').join(email) + ' 🍫');
  }
  if (notifyBtn) notifyBtn.addEventListener('click', openNotifyDialog);
  if (stickyNotifyBtn) stickyNotifyBtn.addEventListener('click', openNotifyDialog);

  if (sticky) {
    sticky.hidden = false;
    sticky.classList.add('is-visible');
  }

  updateForVariant();
})();